"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _pushDataLayer = _interopRequireDefault(require("@lumirental/lumi-web-sdk/dist/utils/gtm/pushDataLayer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * When a branch is selected
 *  Can be branch search
 *  Location based
 *  City list click
 * @param {string} screenName
 * @param {object} selectedBranch
 * @param {string} selectionType
 * @param {string} searchKeyword
 * @param {boolean} locationSearch
 * @param {boolean} cityTapped
 */
function branchSelected(screenName, selectedBranch) {
  var selectionType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var searchKeyword = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var branchName = (0, _get2["default"])(selectedBranch, 'nameEn', '').toLowerCase();
  var distance = (0, _get2["default"])(selectedBranch, 'distance', 0);
  var city = (0, _get2["default"])(selectedBranch, 'cityNameEn', '').toLowerCase();
  var branchType = (0, _get2["default"])(selectedBranch, 'type', '');
  var bookingType = (0, _get2["default"])(selectedBranch, 'carDelivery', false);
  var isAirportBranch = branchType.toLowerCase() === 'airport';
  var cityTapped = selectionType.toLowerCase() === 'city';
  var nearMeTapped = selectionType.toLowerCase() === 'near me';
  var eventData = {
    event: 'branch_selected',
    screen_name: screenName,
    branch_name: branchName,
    distance: distance,
    city: city,
    airport_branch: !!isAirportBranch,
    search_keyword: searchKeyword,
    near_me_tapped: !!nearMeTapped,
    city_tapped: !!cityTapped,
    branch_type: bookingType ? 'delivery' : 'pickup'
  };
  console.log('** gtm event branch_selected: ', eventData);
  (0, _pushDataLayer["default"])(eventData);
}
var _default = exports["default"] = branchSelected;